import React, {
  Component,
  useEffect,
  useState,
  useContext,
  useRef,
} from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { BiPencil } from 'react-icons/bi';
import axios from 'axios';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import LoadingQuote from '../components/widgets/LoadingQuote';
import InputGroup from 'react-bootstrap/InputGroup';
import { RiDeleteBinLine } from 'react-icons/ri'; // Add this import at the top
// or
import { HiOutlineTrash } from 'react-icons/hi';
import Label from 'react-bootstrap/FormLabel';
import CalendarPopover from '../components/create-goal-calendar/CalendarPopover';
import {
  Alert,
  Toast,
  ToastContainer,
  Popover,
  Overlay,
} from 'react-bootstrap';
import MainLayout from '../components/MainLayout';
import { Helmet } from 'react-helmet-async';
import { Routes, Route, useNavigate, useParams } from 'react-router-dom';
import Form from 'react-bootstrap/Form';
import { IoIosArrowRoundBack } from 'react-icons/io';
import Modal from 'react-bootstrap/Modal';
import FloatingGoBackButton from '../components/widgets/FloatingGoBackButton';
import FloatingSaveButton from '../components/widgets/FloatingSaveButton';
import SearchableDropdown from '../components/SearchableDropdown';
import { Watch } from 'react-loader-spinner';
import { LuSettings2 } from 'react-icons/lu';
import TaskManager from '../components/TaskManager';

import 'react-calendar/dist/Calendar.css';
import '../components/create-goal-calendar/custom-calendar.css'; // You'l
import 'react-datepicker/dist/react-datepicker-cssmodules.css';
import SideNav from '../components/SideNav';

const apiUrl = process.env.REACT_APP_API_URL;

const CreateCycleGroup = () => {
  const [showSettings, setShowSettings] = useState(false);
  const [isSharedChecklist, setIsSharedChecklist] = useState(false);
  const [sharedChecklist, setSharedChecklist] = useState('');
  const [isDesktop, setIsDesktop] = useState(false);
  const [moderator, setModerator] = useState('');
  const [cycleName, setCycleName] = useState('');
  const navigate = useNavigate();
  const { groupId } = useParams();
  const [emailNotifications, setEmailNotifications] = useState(true);
  const [loading, setLoading] = useState(true);

  // const handleEmailNotifications = (event) => {
  //   console.log('Checkbox checked:', event.target.checked); // Debugging line
  //   setEmailNotifications(event.target.checked);
  // };

  useEffect(() => {
    setFormState((prevState) => ({
      ...prevState,
      emailNotifications: emailNotifications,
    }));
  }, [emailNotifications]);

  const handleEmailNotifications = (event) => {
    // console.log('Checkbox checked:', event.target.checked);
    setEmailNotifications(event.target.checked);
  };

  // useEffect(() => {
  //   console.log('Email notifications state:', emailNotifications); // Debugging line
  // }, [emailNotifications]); //

  const [formState, setFormState] = useState({
    startDate: '',
    endDate: '',
    group: groupId,
    cycleMembers: [],
    emailNotifications: emailNotifications,
    sharedChecklist: sharedChecklist,
  });
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

  const [users, setUsers] = useState([]);
  const [userNames, setUsernames] = useState([]);

  const [dateError, setDateError] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [groupDetails, setGroupDetails] = useState();
  const [subtasks, setSubtasks] = useState([]);
  const [showPopover, setShowPopover] = useState({});
  const targetRefs = useRef([]);
  const handleSettingsToggle = () => setShowSettings(!showSettings);
  // Toggle popover visibility
  const togglePopover = (index) => {
    setShowPopover((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  useEffect(() => {
    const token = localStorage.getItem('token'); //
    const isLoggedIn = Boolean(localStorage.getItem('token'));

    const fetchUsers = async () => {
      try {
        // if(isLoggedIn){
        const response = await axios.get(`${apiUrl}/groups/${groupId}/users`, {
          headers: {
            'x-auth-token': token,
          },
        });

        // Filter out users without a name
        const filteredUsernames = response.data
          .map((user) => user.name)
          .filter((name) => name);

        setUsernames(filteredUsernames);
        setUsers(response.data);
        //  console.log(response.data);

        if (groupId && isLoggedIn) {
          // Check if adminId is defined
          const response_gd = await axios.get(`${apiUrl}/groups/${groupId}`, {
            headers: {
              'x-auth-token': token,
            },
          });

          const group = response_gd.data;

          setGroupDetails(group);
          setLoading(false);
        }
      } catch (error) {
        console.error(error.message);
      }
    };

    fetchUsers();
  }, []);

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (hasUnsavedChanges) {
        const message =
          'You have unsaved changes. Are you sure you want to leave?';
        event.returnValue = message; // Standard for most browsers
        return message; // For some older browsers
      }
    };
    //  console.log('here in ue2');
    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [hasUnsavedChanges]);

  // Sync selectedDates with formState when the popover opens
  // Sync selectedDates with formState when the popover opens

  const [startDate, setStartDate] = useState(); // empty startDate set when we start initially
  const [endDate, setEndDate] = useState(); // empty endDate set when we start initially

  //const [selectedUsers, setSelectedUsers] = useState([]);

  // Store selected dates
  const [selectedDates, setSelectedDates] = useState([]);
  const [currentSubtask, setCurrentSubtask] = useState(null);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastType, setToastType] = useState('success');

  const handleShowToast = (message, toastType) => {
    setToastMessage(message);
    setToastType(toastType);
    setShowToast(true);
    // Toast shows for 3 seconds
  };

  /*Delete stuff */

  const deleteGoal = (userId, goalIndex) => {
    const updatedMembers = formState.cycleMembers.map((member) =>
      member.user === userId
        ? {
            ...member,
            goals: member.goals.filter((_, index) => index !== goalIndex),
          }
        : member,
    );
    setFormState((prev) => ({ ...prev, cycleMembers: updatedMembers }));
    setHasUnsavedChanges(true);
  };

  const deleteSubtask = (userId, goalIndex, subtaskIndex) => {
    const updatedMembers = formState.cycleMembers.map((member) =>
      member.user === userId
        ? {
            ...member,
            goals: member.goals.map((goal, gIndex) =>
              gIndex === goalIndex
                ? {
                    ...goal,
                    subtasks: goal.subtasks.filter(
                      (_, sIndex) => sIndex !== subtaskIndex,
                    ),
                  }
                : goal,
            ),
          }
        : member,
    );
    setFormState((prev) => ({ ...prev, cycleMembers: updatedMembers }));
    setHasUnsavedChanges(true);
  };

  const handleSelectUser = (selectedUserName) => {
    const user = users.find((u) => u.name === selectedUserName);
    if (
      user &&
      !formState.cycleMembers.some((member) => member.user === user._id)
    ) {
      const newMember = {
        user: user._id,
        goals: [],
      };
      setFormState((prev) => ({
        ...prev,
        cycleMembers: [...prev.cycleMembers, newMember],
      }));
    }
    setHasUnsavedChanges(true);
  };

  /**TRIAL */

  // Adding goals and subtasks methods as before
  const addGoal = (userId) => {
    const updatedMembers = formState.cycleMembers.map((member) =>
      member.user === userId
        ? {
            ...member,
            goals: [...member.goals, { goalName: '', subtasks: [] }],
          }
        : member,
    );
    setFormState((prev) => ({ ...prev, cycleMembers: updatedMembers }));
    setHasUnsavedChanges(true);
  };

  const handleSharedChecklistToggle = () => {
    //console.log('I am being toggled');

    setFormState((prev) => ({
      ...prev,
      sharedChecklist: !prev.sharedChecklist, // Ensure sharedChecklist is toggled in formState
      cycleMembers: !prev.sharedChecklist
        ? prev.cycleMembers.map((member) => ({
            ...member,
            goals: [], // Reset goals if enabling shared checklist
          }))
        : prev.cycleMembers,
    }));

    setIsSharedChecklist((prev) => !prev); // Ensure UI updates with state toggle
  };

  const addSubtask = (userId, goalIndex) => {
    const updatedMembers = formState.cycleMembers.map((member) =>
      member.user === userId
        ? {
            ...member,
            goals: member.goals.map((goal, index) =>
              index === goalIndex
                ? {
                    ...goal,
                    subtasks: [
                      ...goal.subtasks,
                      {
                        subTaskName: '',
                        isCompleted: false,
                        isDaily: false,
                        frequency: {
                          type: 'one-off', // Set default frequency to "one-off"
                          days: [], // Initialize with an empty array or any default days
                        },
                      },
                    ],
                  }
                : goal,
            ),
          }
        : member,
    );
    setFormState((prev) => ({ ...prev, cycleMembers: updatedMembers }));
    setHasUnsavedChanges(true);
  };

  // This function is called when the shared checklist is updated
  const handleChecklistUpdate = (checklist) => {
    console.log('Checklist received:', checklist);
    setSharedChecklist(checklist);
  };

  // Update cycleMembers only when sharedChecklist changes
  useEffect(() => {
    if (sharedChecklist.length === 0) return; // Exit if checklist is empty

    const updatedCycleMembers = users.map((user) => ({
      user: user._id,
      goals: sharedChecklist.map((task) => ({
        goalName: task.taskName,
        subtasks: task.subtasks.map((subtask) => ({
          subTaskName: subtask.subTaskName,
          isCompleted: false,
          frequency: subtask.frequency || 'one-off',
          subtaskProgress: 0,
          completedDays: [],
        })),
      })),
    }));

    setFormState((prev) => ({
      ...prev,
      cycleMembers: updatedCycleMembers,
    }));
  }, [sharedChecklist, users]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    console.log('formState in handleSubmit: ', formState);
    let hasEmptyGoals = false;

    const updatedCycleMembers = formState.cycleMembers.map((member) => {
      const updatedGoals = member.goals.map((goal) => {
        if (goal.subtasks.length === 0) {
          hasEmptyGoals = true;
          return {
            ...goal,
            subtasks: [{ subTaskName: '', isCompleted: false }],
          };
        }
        return goal;
      });
      return { ...member, goals: updatedGoals };
    });

    if (hasEmptyGoals) {
      setFormState((prev) => ({ ...prev, cycleMembers: updatedCycleMembers }));
      handleShowToast(
        'Each goal must have at least one subtask. Empty subtasks have been added.',
        'warning',
      );
      return;
    }

    if (!dateError) {
      const token = localStorage.getItem('token');
      try {
        await axios.post(`${apiUrl}/cycles`, formState, {
          headers: { 'x-auth-token': token },
        });
        handleShowToast('Cycle Saved Successfully!', 'success');
        setHasUnsavedChanges(false);
        navigate('..');
      } catch (error) {
        console.error(error);
        let message = 'An error occurred';
        if (error.response?.data?.message.includes('Cycle limit')) {
          const maxCycles = error.response.data.message.match(/\d+/)[0];
          message = `Sorry, you've reached the maximum limit of ${maxCycles} cycles you can create. Please upgrade your plan :)`;
          setErrorMessage(message);
          setShowErrorModal(true);
        } else {
          handleShowToast('Unexpected Error!', 'danger');
        }
      }
    }
  };

  const handleStartDateChange = (e) => {
    const newStartDate = e.target.value;
    if (formState.endDate && newStartDate > formState.endDate) {
      setDateError('Start date cannot be later than end date.');
    } else {
      setDateError('');
    }
    setFormState((prev) => ({ ...prev, startDate: newStartDate }));
    setHasUnsavedChanges(true);
  };

  const handleEndDateChange = (e) => {
    const newEndDate = e.target.value;
    if (formState.startDate && formState.startDate > newEndDate) {
      setDateError('End date cannot be earlier than start date.');
    } else {
      setDateError('');
    }
    setFormState((prev) => ({ ...prev, endDate: newEndDate }));
    setHasUnsavedChanges(true);
  };

  // Function to navigate back
  const navigateBack = () => {
    if (
      !hasUnsavedChanges ||
      window.confirm(
        'You have unsaved changes. Are you sure you want to leave?',
      )
    ) {
      navigate(-1);
    }
  };

  // Helper function to immutably update subtask
  const updateSubtask = (
    prevState,
    memberUser,
    gIndex,
    sIndex,
    updatedFields,
  ) => {
    return {
      ...prevState,
      cycleMembers: prevState.cycleMembers.map((member) =>
        member.user === memberUser
          ? {
              ...member,
              goals: member.goals.map((goal, goalIdx) =>
                goalIdx === gIndex
                  ? {
                      ...goal,
                      subtasks: goal.subtasks.map((subtask, subtaskIdx) =>
                        subtaskIdx === sIndex
                          ? { ...subtask, ...updatedFields }
                          : subtask,
                      ),
                    }
                  : goal,
              ),
            }
          : member,
      ),
    };
  };

  const frequencyOptions = ['one-Off', 'daily', 'custom'];

  // Function to check if a date is between start and end

  const handleDateChange = (dates, user, gIndex, sIndex, subtask) => {
    //console.log('dates: ', dates);

    // Check if dates is an array or a single date
    const newDates = Array.isArray(dates) ? dates : [dates];
    //console.log('newDates: ', newDates);

    // Update selected dates by merging with existing dates
    setSelectedDates((prevSelectedDates) => {
      // Create a new set of dates to avoid duplicates
      const updatedDates = new Set(
        prevSelectedDates.map((date) => date.toISOString()),
      ); // Use ISO strings for comparison
      newDates.forEach((date) => updatedDates.add(date.toISOString())); // Add new dates

      // Convert back to Date objects
      return Array.from(updatedDates).map((dateString) => new Date(dateString));
    });
    //console.log('selectedDates: ', selectedDates);
  };

  // Custom calendar tile content to show selected state
  const tileContent = ({ date, view }) => {
    if (view === 'month') {
      // Check if this date is selected
      const isSelected = selectedDates.some(
        (selectedDate) => selectedDate.toDateString() === date.toDateString(),
      );

      // Return selected indicator if applicable
      return isSelected ? (
        <div className="selected-date-indicator"></div>
      ) : null;
    }
    return null;
  };

  // Tile Disabled Logic
  const tileDisabled = ({ date, view }) => {
    if (view === 'month') {
      return !isInRange(date); // Disable tiles outside of the range
    }
    return false; // Allow other views to remain clickable
  };

  // Function to Check if Date is in Range
  const isInRange = (date) => {
    const normalizedDate = new Date(date.setHours(0, 0, 0, 0)); // Normalize date
    const normalizedStartDate = new Date(startDate.setHours(0, 0, 0, 0)); // Normalize start date
    const normalizedEndDate = new Date(endDate.setHours(0, 0, 0, 0)); // Normalize end date

    return (
      normalizedDate >= normalizedStartDate &&
      normalizedDate <= normalizedEndDate
    );
  };

  // Add a class to selected dates
  const tileClassName = ({ date, view }) => {
    if (view === 'month') {
      const isSelected = selectedDates.some(
        (selectedDate) => selectedDate.toDateString() === date.toDateString(),
      );
      return isSelected ? 'selected-calendar-date' : null;
    }
    return null;
  };

  const handleSaveSelection = (user, gIndex, sIndex, updatedSubtask) => {
    // Log the current formState to check its structure
    console.log('Current formState before update:', formState);

    // Update the formState directly with the new subtask object
    setFormState((prev) => {
      // Check if cycleMembers exists and is an array
      if (!prev.cycleMembers || !Array.isArray(prev.cycleMembers)) {
        console.error('cycleMembers is not defined or not an array');
        return prev; // Return the previous state if there's an issue
      }

      const updatedCycleMembers = prev.cycleMembers.map((member) => {
        // Check if the current member's user matches the provided user ID
        if (member.user === user) {
          // Check if goals exists and is an array
          if (!member.goals || !Array.isArray(member.goals)) {
            console.error(
              'goals is not defined or not an array for member:',
              member,
            );
            return member; // Return the unchanged member if there's an issue
          }

          // Update the specific member's goals
          const updatedGoals = member.goals.map((goal, goalIndex) => {
            // Check if the goal index matches gIndex
            if (goalIndex === gIndex) {
              return {
                ...goal,
                subtasks: goal.subtasks.map((subtask, subtaskIndex) => {
                  // Check if the subtask index matches sIndex
                  if (subtaskIndex === sIndex) {
                    return {
                      ...subtask,
                      frequency: {
                        ...subtask.frequency,
                        days: updatedSubtask.frequency.days, // Update days with selected dates
                      },
                    };
                  }
                  return subtask; // Return unchanged subtask
                }),
              };
            }
            return goal; // Return unchanged goal
          });

          return {
            ...member,
            goals: updatedGoals, // Update the goals with the new subtasks
          };
        }
        return member; // Return unchanged member
      });

      const newFormState = {
        ...prev,
        cycleMembers: updatedCycleMembers, // Update the cycle members with the new structure
      };

      // Log the updated formState
      console.log('Updated formState:', newFormState);

      return newFormState; // Return the new state
    });

    // Close the popover
    setShowPopover(false);
  };

  // Function to toggle the popover

  const handleFrequencyChange = (
    newFrequencyType,
    member,
    gIndex,
    sIndex,
    subtask,
  ) => {
    const updatedFrequency = {
      type: newFrequencyType,
      days: subtask.frequency?.days || [],
    };

    // Update the subtask frequency
    setFormState((prev) =>
      updateSubtask(prev, member.user, gIndex, sIndex, {
        frequency: updatedFrequency,
      }),
    );

    // Reset selected dates when "custom" is selected
    if (newFrequencyType === 'custom') {
      setSelectedDates([]); // Reset selected dates
      togglePopover(sIndex); // Open the CalendarPopover
    }
  };

  const handleEditSubtask = (userId, gIndex, sIndex) => {
    // Assuming userIndex is the index of the cycle member (user)
    const userIndex = formState.cycleMembers.findIndex(
      (member) => member.user === userId,
    );
    console.log('formState.cycleMembers: ', formState.cycleMembers);

    console.log('userIndex: ', userIndex);
    console.log('userId: ', userId);
    if (userIndex !== -1) {
      // Check if the user exists
      // Set the current subtask index
      setCurrentSubtask(sIndex); // Set the current subtask index
      //setGIndex(gIndex); // Set the goal index

      // Extract the current subtask data from formState
      const currentSubtaskData =
        formState.cycleMembers[userIndex].goals[gIndex].subtasks[sIndex];

      console.log('Current Subtask Data:', currentSubtaskData);

      // Check if the current subtask has frequency days and update selectedDates
      if (currentSubtaskData && currentSubtaskData.frequency) {
        setSelectedDates(
          currentSubtaskData.frequency.days.map((day) => new Date(day)),
        ); // Convert ISO strings back to Date objects
      } else {
        setSelectedDates([]); // Reset if no days are found
      }

      togglePopover(sIndex); // Open the CalendarPopover
    } else {
      console.error('User not found in cycleMembers');
    }
  };

  return (
    <>
      <Row>
        <Col md={2} className="sidebar">
          <SideNav />
        </Col>
        <Col md={10}>
          <Helmet>
            <title>Create Cycle</title>
            <meta
              name="description"
              content="Asquad - accountability made easy"
            />
          </Helmet>
          {loading ? (
            <LoadingQuote />
          ) : (
            <Container>
              <MainLayout title="Create Cycle">
                <p className="h-gd-title">
                  {groupDetails && groupDetails.groupname}{' '}
                </p>

                <Toast
                  onClose={() => setShowToast(false)}
                  show={showToast}
                  delay={3000}
                  autohide
                  bg={toastType === 'success' ? 'success' : 'danger'}
                  style={{
                    position: 'fixed',
                    bottom: 70,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    zIndex: 9999,
                    color: 'white ',
                  }}
                >
                  <Toast.Body>{toastMessage}</Toast.Body>
                </Toast>

                <Form className="form-wrapper" onSubmit={handleSubmit}>
                  {/* Start and End Date Inputs */}

                  {/* Settings Button */}

                  <Modal
                    show={showSettings}
                    onHide={handleSettingsToggle}
                    centered
                  >
                    {/* ModalStart */}
                    <Modal.Header closeButton>
                      <Modal.Title>Cycle Settings</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <Form>
                        <Form.Group controlId="enableEmailNotifications">
                          <Form.Check
                            type="switch"
                            label="Enable Email Notifications"
                            checked={emailNotifications}
                            onChange={() =>
                              setEmailNotifications(!emailNotifications)
                            }
                          />
                        </Form.Group>
                        <Form.Group controlId="sharedChecklist">
                          <Form.Check
                            type="switch"
                            label="Shared Checklist"
                            checked={isSharedChecklist}
                            onChange={handleSharedChecklistToggle}
                          />
                        </Form.Group>
                      </Form>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button variant="primary" onClick={handleSettingsToggle}>
                        Save
                      </Button>
                    </Modal.Footer>
                  </Modal>
                  <Row>
                    <Col md={6} lg={2} className="text-center mt-3 mt-md-0">
                      <div
                        className="settings-set"
                        onClick={handleSettingsToggle}
                      >
                        <div className="settings-icon">
                          <LuSettings2
                            color="#68b422"
                            size="20"
                            fontWeight={700}
                          />
                        </div>
                        <p className="settings-text"> settings</p>
                      </div>
                    </Col>
                  </Row>
                  <Row className="justify-content-center mb-3">
                    <Col md={6} lg={3}>
                      <Form.Group>
                        <Form.Label>Start Date</Form.Label>
                        <Form.Control
                          type="date"
                          name="startDate"
                          value={formState.startDate}
                          required="true"
                          onChange={handleStartDateChange}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6} lg={3}>
                      <Form.Group>
                        <Form.Label>End Date</Form.Label>
                        <Form.Control
                          type="date"
                          name="endDate"
                          value={formState.endDate}
                          onChange={handleEndDateChange}
                          required="true"
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  {/* Searchable Dropdown centered under the date inputs */}

                  <Row className="justify-content-center mb-3">
                    {/* <Col md={6} lg={6}>
                      <SearchableDropdown
                        options={userNames}
                        onSelect={handleSelectUser}
                      />
                    </Col> */}
                  </Row>
                  {isSharedChecklist ? (
                    <TaskManager onChecklistUpdate={handleChecklistUpdate} />
                  ) : (
                    <>
                      <Row className="justify-content-center mb-3">
                        <Col md={6} lg={6}>
                          <SearchableDropdown
                            options={userNames}
                            onSelect={handleSelectUser}
                          />
                        </Col>
                      </Row>
                      {formState.cycleMembers.map((member, mIndex) => (
                        <div key={mIndex} className="mb-3">
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                            }}
                          >
                            <Card.Title>
                              {users.find((u) => u._id === member.user)?.name}
                            </Card.Title>
                            <div
                              className="add-goal-btn"
                              onClick={() => addGoal(member.user)}
                            >
                              Add Goal
                            </div>
                          </div>
                          {member.goals.map((goal, gIndex) => (
                            <div key={gIndex} className="mt-2">
                              <Card.Subtitle>
                                {`${
                                  users.find((u) => u._id === member.user)?.name
                                }'s Goal #${gIndex + 1}`}
                              </Card.Subtitle>
                              <InputGroup className="mb-2">
                                <Form.Control
                                  type="text"
                                  value={goal.goalName}
                                  onChange={(e) => {
                                    const goalName = e.target.value;
                                    setFormState((prev) => {
                                      const updatedCycleMembers =
                                        prev.cycleMembers.map((mem) =>
                                          mem.user === member.user
                                            ? {
                                                ...mem,
                                                goals: mem.goals.map((g, gi) =>
                                                  gi === gIndex
                                                    ? {
                                                        ...g,
                                                        goalName: goalName,
                                                      }
                                                    : g,
                                                ),
                                              }
                                            : mem,
                                        );
                                      return {
                                        ...prev,
                                        cycleMembers: updatedCycleMembers,
                                      };
                                    });
                                  }}
                                  placeholder="Goal Name"
                                  className="goal-input"
                                  required={true}
                                />

                                <Button
                                  className="delete-goal-btn"
                                  variant="outline-danger"
                                  size="sm"
                                  onClick={() =>
                                    deleteGoal(member.user, gIndex)
                                  }
                                  style={{
                                    height: '25px',
                                    width: '30px',
                                    padding: '0',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    borderRadius: '4px',
                                    margin: 'auto 0', // This helps with vertical centering
                                  }}
                                >
                                  <RiDeleteBinLine size={14} />
                                </Button>
                              </InputGroup>
                              <div
                                className="add-sbtask-btn"
                                onClick={() => addSubtask(member.user, gIndex)}
                              >
                                Add Subtask
                              </div>

                              {goal.subtasks.map((subtask, sIndex) => (
                                <InputGroup className="mb-4" key={sIndex}>
                                  {/* Subtask Name Input */}
                                  <Form.Control
                                    type="text"
                                    value={subtask.subTaskName}
                                    onChange={(e) => {
                                      const newSubTaskName = e.target.value;
                                      setFormState((prev) =>
                                        updateSubtask(
                                          prev,
                                          member.user,
                                          gIndex,
                                          sIndex,
                                          { subTaskName: newSubTaskName },
                                        ),
                                      );
                                    }}
                                    placeholder="Subtask Name"
                                    required
                                    className="subtask-input"
                                  />

                                  {/* Frequency Dropdown */}
                                  <div
                                    className="d-flex align-items-center frequency-dropdown-container"
                                    style={{
                                      maxWidth:
                                        subtask.frequency?.type === 'custom'
                                          ? '180px'
                                          : '120px',
                                    }}
                                  >
                                    <Form.Select
                                      value={
                                        subtask.frequency?.type || 'one-off'
                                      }
                                      onChange={(e) => {
                                        const newFrequencyType = e.target.value;
                                        handleFrequencyChange(
                                          newFrequencyType,
                                          member,
                                          gIndex,
                                          sIndex,
                                          subtask,
                                        );

                                        // Open popover immediately when "Custom" is selected
                                        if (newFrequencyType === 'custom') {
                                          togglePopover(sIndex);
                                        }
                                      }}
                                      className="frequency-dropdown"
                                      ref={(ref) =>
                                        (targetRefs.current[sIndex] = ref)
                                      }
                                      style={{
                                        borderRadius:
                                          subtask.frequency?.type === 'custom'
                                            ? '0.25rem 0 0 0.25rem'
                                            : '0.25rem',
                                      }}
                                    >
                                      {frequencyOptions.map((option) => (
                                        <option key={option} value={option}>
                                          {option}
                                        </option>
                                      ))}
                                    </Form.Select>

                                    {/* Edit button only shown for Custom frequency */}
                                    {subtask.frequency?.type === 'custom' && (
                                      <Button
                                        variant="outline-secondary"
                                        size="sm"
                                        className="edit-subtask-btn"
                                        onClick={() =>
                                          handleEditSubtask(
                                            member.user,
                                            gIndex,
                                            sIndex,
                                          )
                                        }
                                        style={{
                                          height: '25px',
                                          width: '30px',
                                          padding: '0',
                                          borderLeft: 'none',
                                          borderRadius: '0 4px 4px 0',
                                          display: 'flex',
                                          alignItems: 'center',
                                          justifyContent: 'center',
                                        }}
                                      >
                                        <BiPencil size={12} />
                                      </Button>
                                    )}

                                    {/* Custom Day Picker Popover */}

                                    {subtask.frequency?.type === 'custom' && (
                                      <CalendarPopover
                                        key={sIndex}
                                        showPopover={showPopover[sIndex]}
                                        targetRef={targetRefs.current[sIndex]}
                                        sIndex={sIndex}
                                        gIndex={gIndex}
                                        selectedDates={selectedDates} // Pass the selected dates for the current subtask
                                        togglePopover={togglePopover}
                                        handleDateChange={handleDateChange}
                                        tileContent={tileContent}
                                        tileDisabled={tileDisabled}
                                        tileClassName={tileClassName}
                                        start={formState.startDate}
                                        end={formState.endDate}
                                        subtask={subtask}
                                        user={member.user}
                                        handleSaveSelection={
                                          handleSaveSelection
                                        }
                                      />
                                    )}
                                  </div>

                                  {/* Delete Subtask Button */}

                                  <Button
                                    className="delete-subtask-btn"
                                    variant="outline-danger"
                                    size="sm"
                                    onClick={() =>
                                      deleteSubtask(member.user, gIndex, sIndex)
                                    }
                                    style={{
                                      height: '25px',
                                      width: '30px',
                                      padding: '0',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      borderRadius: '4px',
                                      margin: 'auto 0', // This helps with vertical centering
                                    }}
                                  >
                                    <RiDeleteBinLine size={14} />
                                  </Button>
                                </InputGroup>
                              ))}
                            </div>
                          ))}
                        </div>
                      ))}
                    </>
                  )}

                  {dateError && <Alert variant="danger">{dateError}</Alert>}
                  <FloatingGoBackButton onClick={navigateBack} />
                  <FloatingSaveButton type="submit" />

                  {/* <Button className="create-cycle-btn" type="submit" >Submit Form</Button> */}
                </Form>
              </MainLayout>
            </Container>
          )}
        </Col>
      </Row>
      <Modal show={showErrorModal} onHide={() => setShowErrorModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Error</Modal.Title>
        </Modal.Header>
        <Modal.Body>{errorMessage}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowErrorModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CreateCycleGroup;
